<template>
  <div class="main">
    <!-- title -->
    <h3 class="title" content="edit" placement="bottom">
      Campaign Management - Campaign Popup
    </h3>
    <!-- table shares one panel -->
    <div class="client-panel">
      <div class="client-panel__toolbar">
        <columns-control
          :columns="columnsConfig"
          storage-key="cms.campaignManagement.columns"
          @change="onColumnsChange"
        ></columns-control>
      </div>
      <el-table :data="tableData" >
        <el-table-column v-if="isColumnVisible('salesOffice')" prop="salesOffice" label="Sales Office" width="600">
            <template slot-scope="scope">{{$commonjs.salesOfficeMap(scope.row.salesOffice)}}</template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('title')" prop="title" label="Title"></el-table-column>
        <el-table-column v-if="isColumnVisible('postOnline')" prop="postOnline" label="Post">
             <template slot-scope="scope">{{scope.row.postOnline?'Online':'Offline'}}</template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('updatedAt')" prop="updatedAt" label="Last update" :formatter="$commonjs.tableFormatDateTime"></el-table-column>
        <el-table-column label="Operation">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Edit"
              placement="top"
            >
              <em class="edit" style="margin-right:10px" @click="handleEdit(scope.row)"></em>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  campaginList
} from "@/request/api";
export default {
  name: "campaign",
  data() {
    return {
      tableData: [],
      currentSize: 10,
      currentPage: 1,
      formLabelWidth: "96px",
      formUser: {
        id: 0,
        username: "",
        password: "",
        roles: []
      },
      columnsConfig: [
        { prop: "salesOffice", label: "Sales Office", visible: true },
        { prop: "title", label: "Title", visible: true },
        { prop: "postOnline", label: "Post", visible: true },
        { prop: "updatedAt", label: "Last update", visible: true },
      ],
      visibleColumnProps: ["salesOffice", "title", "postOnline", "updatedAt"],
    };
  },
  methods: {
    isColumnVisible(prop) {
      return this.visibleColumnProps.includes(prop);
    },
    onColumnsChange(visibleProps) {
      this.visibleColumnProps = visibleProps;
    },
    getList() {
      let params={
        page:this.currentPage,
        size:this.currentSize
      };
      campaginList(params).then(res=>{
        this.tableData = res.data;
      })
    },
    handleEdit(row) {
      this.$router.push({path:'/editCampaign/'+row.id})
    },
  },
  created: function() {
    this.$emit("header", true);
    this.getList();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.client-panel {
  background: #fff;
  border: 1px solid #e6ebee;
  border-radius: 8px;
  overflow: hidden;
}

.client-panel__toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 14px 20px;
  border-bottom: 1px solid #e6ebee;
}

.client-panel /deep/ .el-table {
  border: none;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/notification/campaign.vue